import { AutocompleteInput, type AutocompleteInputProps } from "react-admin";

import { useClientAppAllowedLandings } from "./useClientAppAllowedLandings";

type Props = Omit<AutocompleteInputProps, "resource"> & {
  selectedClientAppId?: string;
};

export const ClientAppAllowedLanding = ({
  selectedClientAppId,
  ...rest
}: Props) => {
  const { allowedLandings, isLoading } =
    useClientAppAllowedLandings(selectedClientAppId);

  return (
    <AutocompleteInput
      {...rest}
      choices={allowedLandings}
      isLoading={isLoading}
      optionText="title"
      optionValue="@id"
    />
  );
};
